function initSingleComponent(
  fn: Function,
  container: HTMLElement,
  ...args: unknown[]
): void | null {
  try {
    if (container) {
      return fn(container, ...args);
    }
  } catch (e) {
    console.error(e);
    return null;
  }

  return null;
}

function initMultipleComponents(
  fn: Function,
  containers: NodeListOf<HTMLElement>,
  ...args: unknown[]
): void[] | null {
  try {
    return Array.from(containers).map((container) => fn(container, ...args));
  } catch (e) {
    console.error(e);
    return null;
  }
}

// Initialization of Vanilla JS components
export default {
  single: initSingleComponent,
  multiple: initMultipleComponents,
};
